import { OnInit, Component, ViewChild, Output, EventEmitter } from "@angular/core";
import { Observable, of, Subject, Subscription } from "rxjs";
import { Router } from "@angular/router";
import { ClaimsService } from "src/app/_services/common/claims.service";
import { TranslateService } from "@ngx-translate/core";
import { HowDoIVideoLinks } from "src/app/common/commonvariables";
import { OrganisationSettingService } from "src/app/_services/organisation-setting/organisation-setting.service";
import { BaseComponent } from "src/app/shared/base/base-component";
import { MarketingPopup } from "src/app/_models/common/marketing-popup";
import { ApprovalRuleSaveRequest } from "src/app/_models/application-setting/approval-rule";
import { ApiRequest, ApprovalRuleSetting, CostCentreStatusEnum, FunctionPackageEnum, GetAllEmployeesRequest, IGetAllEmployeesRequest, LogObjectActionTemplateEnum } from "src/app/_models";
import { OrganisationFunctionService } from "src/app/_services/organisation-setting/organisation-function.service";
import { ToastrService } from "ngx-toastr";
import { CostCentreService, ManageempService } from "src/app/_services";
import { environment } from "src/environments/environment";
import { Claims } from "src/app/_models/common/claims";
import { map } from "rxjs/operators";
import { EmployeeStatusEnum } from "src/app/_models/common/manage-emp-enum.enum";
import { LoggingPanelModel } from "src/app/_models/common/LoggingPanelModel";
import { LoggingPanelService } from "src/app/_services/logging-panel/logging-panel.service";
import { VideoIconComponent } from "src/app/video-icon";
import { IRequestCostCentreByOrg, RequestCostCentreByOrg } from "src/app/_models/costCentre/costCentre";

@Component({
    selector: "approval-rule",
    templateUrl: "./approval-rule.component.html",
    standalone: false
})
export class ApprovalRuleComponent extends BaseComponent implements OnInit {
    @Output() closePanelEvent = new EventEmitter<boolean>();
    @ViewChild(VideoIconComponent) videoIconComponent: VideoIconComponent;
    claimsSubscription: Subscription;
    claims: Claims;
    marketingVideoUrl: string = '';
    hasFormChanges: boolean = false;
    disableSave: boolean = true;
    autoApprovalRules: number[] = [ApprovalRuleSetting.AutomaticA, ApprovalRuleSetting.AutomaticB, ApprovalRuleSetting.AutomaticC, ApprovalRuleSetting.AutomaticD, ApprovalRuleSetting.AutomaticE];
    approvalRuleSetting: number;
    isCostCentrePurchased: boolean;
    employeesWithoutCostCentre: number = 0;
    allEmployeesList: any;
    costCentreMarketingPopupModel: any;
    showCostCentreMarketingPopup: boolean = false;
    claimantErrorLabel: string = '';
    infoToaster: any;
    costCentreList: any = [];
    noActiveCostCentres: boolean = false;
    showAlertPanel: boolean = false;

    constructor(
        private router: Router,
        private claimsService: ClaimsService,
        private translate: TranslateService,
        private toastr: ToastrService,
        private orgSettingService: OrganisationSettingService,
        private organisationFunctionService: OrganisationFunctionService,
        private manageEmpService: ManageempService,
        private loggingPanelService: LoggingPanelService,
        private costCentreService: CostCentreService,
    ) {
        super();
        this.claimsSubscription = this.claimsService.currentClaims.subscribe((claims) => {
            this.claims = claims;
            this.approvalRuleSetting = claims.ApprovalRuleSetting ? claims.ApprovalRuleSetting : ApprovalRuleSetting.Manual;
        });

        const functions = [FunctionPackageEnum.SetupCostCentre_Assign_toClaimants]
        this.organisationFunctionService.checkFunctionsSubscribed(functions, this.claims.OrgId).subscribe(subscription => {
            this.isCostCentrePurchased = subscription.indexOf(FunctionPackageEnum.SetupCostCentre_Assign_toClaimants) > -1;
        });
    }

    ngOnInit(): void {
        this.costCentreMarketingPopupModel = new MarketingPopup(
            this.translate.instant('cost_center_heading'),
            this.translate.instant("cost_centre_marketing_pop_text"),
            this.translate.instant("cost_centre_marketing_pop_text1"),
            "",
            "../../assets/images/Cost-Centre_marketing_image.svg",
            "../../assets/images/setup_cost_centre_screen.png",
            "",
            FunctionPackageEnum.SetupCostCentre_Assign_toClaimants,
            this.translate.instant('cost_center_heading'),
            "cccustomer/costcentre",
            0, 0
        );
        this.getCostCentersForOrg();
    }

    ngOnDestroy() {
        this.claimsSubscription.unsubscribe();
    }

    canDeactivate() {
        return !this.hasFormChanges;
    }

    fnBacktoWizard()
    {
        this.closePanelEvent.emit(true);
    }

    fnGoBackToSettings() {
        if (!this.infoToaster) {
            if (localStorage.getItem("isRedirectFromMySubscriptionSettingPage") == "1") {
                this.router.navigate(["mysubscription"]);
            } else {
                this.router.navigate(["mysubscription"]);
            }
        }
    }

    goToAssignApprovers() {
        if (!this.infoToaster) {
            if (!this.claims.ApprovalRuleSetting || this.claims.ApprovalRuleSetting == ApprovalRuleSetting.Manual) {
                this.router.navigate(["/orgsetting/manageemployee"], {
                    queryParams: { step: "4" },
                  });
            }
            else {
                this.router.navigate(["/orgsetting/manageemployee"], {
                    queryParams: { step: "5" },
                  });
            }
        }
    }

    goToCostCentrePage() {
        if (!this.infoToaster) {
            this.closeAlertPanel();
            localStorage.setItem("IsRedirectFromApprovalRulePage", "1");
            if(this.noActiveCostCentres){
                let url = "cccustomer/ccwizard";
                    this.router.navigate([url], {
                    queryParams: {
                    step: "2",
                    },
                });
            }
            else {
                let url = "cccustomer/ccwizard";
                this.router.navigate([url], {
                    queryParams: {
                        step: "3",
                    },
                });
            }
        }
    }

    goToManageEmployees() {
        if (!this.infoToaster) {
            this.router.navigate(["orgsetting/manageemployee"]);
        }
    }

    fnShowConfigureshowLoggingAlertPanel() {
        if (!this.infoToaster) {
            const model = new LoggingPanelModel(
                this.claims.OrgId.toString(),
                LogObjectActionTemplateEnum.ConfigureApprovalRule.toString(),
                "0"
            );
            this.loggingPanelService.onShowLogPanel(model);
        }
    }

    setMarketingVideoUrl(id) {
        this.marketingVideoUrl = '';
        switch (id) {
            case 1:
                this.marketingVideoUrl = HowDoIVideoLinks.ConfigureApproverRules;
                break;
            case 2:
                this.marketingVideoUrl = HowDoIVideoLinks.AssignApproversToClaimants;
                break;
            case 3:
                this.marketingVideoUrl = HowDoIVideoLinks.AssignApproversToCostCentre;
                break;
        }
    }

    onMarketingPopupClosed() {
        this.showCostCentreMarketingPopup = false;
        setTimeout(() => {
            this.approvalRuleSetting = ApprovalRuleSetting.Manual;
        }, 100);
    }

    closeAlertPanel() {
        this.showAlertPanel = false;
        this.approvalRuleSetting = this.claims.ApprovalRuleSetting;
        this.hasFormChanges = false;
        this.disableSave = true;
    }

    onApprovalRuleChange(setting) {
        this.showCostCentreMarketingPopup = false;

        if (setting != this.approvalRuleSetting) {

            this.approvalRuleSetting = setting;

            if (!this.isCostCentrePurchased && this.autoApprovalRules.indexOf(setting) > -1) {
                this.showCostCentreMarketingPopup = true;
                return;
            }

            this.hasFormChanges = true;
            this.disableSave = false;
        }
    }
    getCostCentersForOrg() {
        let costCentreRequest = new ApiRequest<IRequestCostCentreByOrg>("SoloGetCostCentresForOrg",1.0,"111");
        let costCentreRequestInfo = new RequestCostCentreByOrg(this.claims.OrgId,0,0,0,'');
        costCentreRequest.requestInfo = costCentreRequestInfo;
        this.costCentreService.GetCostCentresForOrg(costCentreRequest)
          .subscribe((response: any) => {
            if (response.responseInfo != null) {
              this.costCentreList = response.responseInfo.costCentreList.filter(it=>it.status == CostCentreStatusEnum.Active);           
            }
          });
      }

    validateUsers(): Observable<boolean> {
        if (this.autoApprovalRules.indexOf(this.approvalRuleSetting) > -1) {
            let request = new ApiRequest<IGetAllEmployeesRequest>("GetAllEmployees", environment.applicationVersion, environment.requestId);
            let requestInfo = new GetAllEmployeesRequest(this.claims.OrgId);
            request.requestInfo = requestInfo;
            this.manageEmpService.DropOrgAllEmployeesCache();
            if(this.costCentreList.length == 0){
                this.claimantErrorLabel = this.translate.instant('no_cc_for_assignment');
                this.removeInfoToaster();
                this.noActiveCostCentres = true;
                this.showAlertPanel = true;
                return of(false);
            }
            return this.manageEmpService.GetAllClaimants(request).pipe(map(employees => {
                if (employees && employees.length > 0) {
                    this.allEmployeesList = employees;
                    this.employeesWithoutCostCentre = employees.filter(e => !e.costCentreId && e.status != EmployeeStatusEnum.Inactive).length;
                    if (this.employeesWithoutCostCentre) {
                        this.claimantErrorLabel = this.translate.instant('claimants_without_cost_centre').replace('{0}', this.employeesWithoutCostCentre.toString());
                        this.removeInfoToaster();
                        this.showAlertPanel = true;
                        return false;
                    }
                }
                return true;
            }));
        }
        else {
            return of(true);
        }
    }

    saveApprovalRules() {
        this.disableSave = true;
        this.infoToaster = this.toastr.info(this.translate.instant('request_processing_info'), '', {
            disableTimeOut: true,
            tapToDismiss: false
        });
        this.validateUsers().subscribe(result => {
            if (result) {
                const approvalRuleSaveRequest = new ApprovalRuleSaveRequest(
                    this.approvalRuleSetting,
                    this.getApprovalRuleText(this.claims.ApprovalRuleSetting),
                    this.getApprovalRuleText(this.approvalRuleSetting),
                    this.claims.FinanceManager
                )
                this.assignCostCentresToExpense().subscribe(result => {

                    this.orgSettingService.saveApprovalRuleSetting(approvalRuleSaveRequest).subscribe(() => {

                        this.removeInfoToaster();
                        this.toastr.success(this.translate.instant("success"));

                        this.claims.ApprovalRuleSetting = this.approvalRuleSetting;
                        this.claimsService.updateClaims(this.claims);
                        this.hasFormChanges = false;
                    });

                });
            }
        });
    }

    removeInfoToaster() {
        if (this.infoToaster) {
            this.toastr.remove(this.infoToaster.toastId);
            this.infoToaster = null;
        }
    }

    assignCostCentresToExpense(): Observable<boolean> {
        if (this.claims.ApprovalRuleSetting == ApprovalRuleSetting.Manual && this.autoApprovalRules.indexOf(this.approvalRuleSetting) > -1) {
            
            const empCCMap = this.allEmployeesList.map(e => {
                return {
                    claimantId: e.employeeID,
                    costCentreId: e.costCentreId
                };
            });
            return this.manageEmpService.AssignCostCentreToExpenses(empCCMap);
        }
        else {
            return of(true);
        }
    }

    getApprovalRuleText(approvalRuleId) {
        let text = '';
        switch (approvalRuleId) {
            case 1:
                text = this.translate.instant('label_manual_assignment');
                break;
            case 2:
                text = this.translate.instant('label_auto_assignment') + ' - ' + this.translate.instant('auto_approval_rule_a');
                break;
            case 3:
                text = this.translate.instant('label_auto_assignment') + ' - ' + this.translate.instant('auto_approval_rule_b');
                break;
            case 4:
                text = this.translate.instant('label_auto_assignment') + ' - ' + this.translate.instant('auto_approval_rule_c');
                break;
            case 5:
                text = this.translate.instant('label_auto_assignment') + ' - ' + this.translate.instant('auto_approval_rule_d');
                break;
            case 6:
                text = this.translate.instant('label_auto_assignment') + ' - ' + this.translate.instant('auto_approval_rule_e');
                break;
        }
        return text;
    }
    IsvideoActive(id) {
        this.setMarketingVideoUrl(id);
        this.videoIconComponent.showVideofromother(true);
    }
}
